import { createSlice } from "@reduxjs/toolkit";
import instance from "../../../api/api.js";

export const fectchRevenuGlobale = (payload) => async (dispatch) => {
  try {
    const data = {
      annee: payload.$y,
    };
    const response_revenu_globale = await instance.post(
      "revenuProprietesGlobale",
      data
    );
    console.log("response_revenu_globale", response_revenu_globale);
    dispatch(
      fetch_Statistiques_Revenu_Globale({
        data: response_revenu_globale.data.data,
      })
    );
  } catch (error) {
    console.log();
  }
};

export const revenuGlobaleReducer = createSlice({
  name: "revenuGlobale",
  initialState: {
    data_revenu: [],
  },
  reducers: {
    fetch_Statistiques_Revenu_Globale: (state, action) => {
      return {
        ...state,
        data_revenu: action.payload.data,
      };
    },
  },
});

export const { fetch_Statistiques_Revenu_Globale } =
  revenuGlobaleReducer.actions;
export default revenuGlobaleReducer.reducer;
